export const IT = {

index:{
    title_general: "Simulatore di immersione",
que_hace_txt: "Cosa fa?",
objetivo: "L'obiettivo non è simulare l'immersione, è migliorare il vero subacqueo.",
modelos_txt_1: "Modelli",
instrumentos_txt: "Strumenti",
seguridad_txt: "Sicurezza",

que_se_pierde: "Cosa si perde insegnando la subacquea senza simulazione?",
teoria_de_perdida: `

        <span style="color:#dfbb73;font-size: 20px;">"La teoria insegna cosa fare. La simulazione insegna perché farlo"</span>

        <br><br>Senza simulazione, molti concetti rimangono astratti. Gli studenti memorizzano limiti, procedure e tabelle, ma hanno difficoltà a visualizzare come le loro decisioni influenzino effettivamente l'assorbimento dei gas, la decompressione, l'esposizione all'ossigeno e la sicurezza dell'immersione.
        <br><br>La simulazione trasforma processi invisibili in esperienze visive e interattive. Permette di sperimentare scenari, analizzare conseguenze e capire come piccoli cambiamenti di profondità, tempo o velocità di risalita possano modificare l'intero profilo di un'immersione.
        <br><br>Per gli istruttori, significa passare dallo spiegare concetti al dimostrare come funzionano in tempo reale.
        <br><strong>Perché l'obiettivo non è che l'allievo ricordi una regola. È che comprenda le conseguenze delle sue decisioni prima di entrare in acqua.</strong>`,



faq_txt: "FAQ",
login_txt: "Login",

experiencia_interactiva: "Simulatore di immersione | Addestramento a secco",

que_hace_2: "Divantys ti aiuta a capire la subacquea prima di entrare in acqua. Riducendo i rischi, accelerando l'apprendimento e migliorando le decisioni reali sotto pressione.",


visualiza: "Domina la teoria dell’immersione. <strong>Impara a gestire e ottimizzare le tue immersioni</strong> prima di entrare in acqua",
que_hace_4: `
                <strong>Le immersioni sono costose; imparare non deve esserlo.</strong><br>
                Allenati nel simulatore, non durante un'immersione che stai pagando.<br>
                Allenati a secco, acquisisci esperienza e sfrutta al massimo ogni minuto della tua avventura subacquea.`,



        all_levels: "Per sub principianti e studenti fino a sub avanzati e istruttori", 
safety_gestion: "Gestisci ed esegui le soste di sicurezza",
aire_profundidad: "Estendi le tue immersioni gestendo la profondità",
gestion_deco: "Gestisci ed esegui le tue soste di decompressione",
ppo2_gestion: "Gestisci e visualizza la PPO2 con la profondità",

openModalBtn: "Vedi riepilogo",

ilustra: `
Il simulatore ti insegna ad agire correttamente di fronte agli errori,
  mostrandoti il futuro delle tue decisioni prima di entrare in acqua.
`,
preguntas_estrategicas_aprendizaje: `
Quindi la domanda davvero importante è:<br>
  <ul>
    <li>Cosa succederebbe se prendessi una decisione diversa?</li>
    <li>Cosa succede se rimango cinque minuti in più sul fondo?</li>
    <li>Cosa succede se salgo troppo velocemente?</li>
    <li>Come cambiano i miei tessuti se uso un'altra miscela di gas?</li>
    <li>In che modo una sosta più profonda o più lunga influisce sul mio profilo di decompressione?</li>
  </ul>
La simolazione permette di rispondere a queste domande in modo immediato, visivo e sicuro.`,
relacion_pp: "Anticipare l'errore è il miglior progresso di un subacqueo",
ndl: "Limiti senza decompressione (NDL)",
absorcion: "Assorbimento di azoto (tessuti)",
exposicion: "Esposizione all’ossigeno (PPO₂ / CNS)",
habitos_asenso: "Abitudini di risalita più sicure",
consumo_aire: "Consumo d’aria e riserva",
buceo_recreativo: "Immersione ricreativa",
nitrox_compatible: "Compatibile Nitrox",
hud: "HUD sullo schermo",
mobil_desktop: "Mobile + Desktop",
startCta: "Entra nel simulatore",
que_incluye: "Vedi cosa include",
tiempo: "Consiglio: puoi accelerare il tempo per osservare più rapidamente l’evoluzione degli indicatori (ad esempio 2×, 5× o 10×).",
que_hace_3: "Cosa fa questo simulatore",
inmersion_virtual: "Divantys Dive Simulator è una piattaforma interattiva di simulazione e apprendimento dell'immersione che consente di visualizzare in tempo reale i processi fisici e fisiologici che avvengono durante un'immersione. Il suo obiettivo è trasformare concetti complessi della teoria dell'immersione, della decompressione e della fisiologia umana in un'esperienza visiva facile da comprendere per subacquei, studenti, istruttori e professionisti del settore. Divantys funziona come un laboratorio virtuale dove puoi esplorare come il corpo umano risponde a diversi profili di immersione, miscele di gas, profondità e tempi di esposizione.",
experiencia_3d: "Esperienza 3D controllabile",
movimiento_cacara: "Movimento e camera con controlli adattati per mobile, tablet e PC.",
joistick_movimiento: "Joystick di movimento",
joistick_rotacion: "Joystick di visuale/rotazione",
neutral_flotabilidad: "Zona neutra per la stabilità",
indicadores_hud: "Indicatori HUD",
instrumentos_visuales: "Strumenti visivi sullo schermo per una comprensione immediata.",
tanque: "Bombola: bar / PSI / percentuale",
barra_nitrogeno: "Barra di azoto (educativa)",
ndl_estado: "NDL e stato della risalita",
reporte: "Report completo",
resumen: "Riepilogo dell’immersione per apprendimento e analisi.",
profundidad_maxima: "Profondità massima",
tiempo_total: "Tempo totale",
ndl_total: "NDL totale e rimanente",
ceiling: "Ceiling (profondità minima sicura)",
modelos_txt: "Modelli e concetti rappresentati",
simulador_implementa: "Il simulatore implementa modelli fisiologici e regole educative comuni nell’immersione ricreativa: assorbimento e rilascio di azoto nei tessuti, limiti senza decompressione ed esposizione all’ossigeno.",
modelo_tejidos: "Modello dei tessuti (16 compartimenti)",
simulador_carge_nitrogeno: "Simula il carico di azoto in diversi tessuti con velocità differenti, permettendo di stimare saturazione, “ceiling” e comportamento nelle immersioni ripetitive.",
expoosicion_o2: "Esposizione all’ossigeno (PPO₂ / CNS)",
calculo_po2: "Calcola la PPO₂ in base alla profondità e alla frazione di ossigeno (FO₂), e accumula l’esposizione CNS con un modello di limiti basato sulla PPO₂. Include livelli di allerta (OK / WARNING / DANGER).",
ndl2: "NDL (No Decompression Limit)",
caluclo_ndl: "Calcola un NDL “ricreativo” basato su profondità e tempo, con supporto per Nitrox (EAD).",
ndl_total_permitido: "NDL totale consentito",
ndl_restante: "NDL rimanente in base al profilo",
interpretacion_riesgos: "Interpretazione educativa del rischio",
ceiling_asecenso: "Ceiling e risalita",
estimacion_profundidad_ceiling: "Stima una profondità minima sicura (ceiling) e valuta se la risalita può essere effettuata senza soste.",
ceiling_metros: "Ceiling in metri",
deteccion_parada: "Rilevamento di “sosta richiesta”",
recomendacion_parada: "Raccomandazione di sosta di sicurezza",
inmersiones_repetitivas: "Immersioni ripetitive",
carga_residual: "Mantiene il carico residuo tra le immersioni e simula gli intervalli in superficie.",
tejidos_conservan: "I tessuti si conservano tra le immersioni",
intervalo_superficie: "L’intervallo in superficie riduce il carico",
aprendizaje_acumulacion: "Apprendimento dell’accumulo residuo",
instrumentos_visualizacion_hud: "Strumenti e visualizzazione (HUD)",
facilitar_comprension: "Per facilitare la comprensione, il simulatore mostra strumenti visivi sullo schermo durante l’immersione. Il suo scopo è che l’utente “veda” come i concetti cambiano in base al suo comportamento.",
tanque_aire: "Bombola d’aria (AL80)",
simula_consumo_sac: "Simula il consumo in base al SAC, alla pressione ambiente e al tempo simulato.",
presion_bar_psi: "Pressione in bar e PSI",
gas_restante: "Percentuale rimanente",
alerta_reserva: "Allerta riserva (es. 35 bar)",
sin_aire: "Stato “senza aria” (out of air)",
barra_nitrogeno_2: "Barra di azoto",
visualizacion_educativa: "Visualizzazione educativa dell’aumento/diminuzione del carico.",
suavisado_visual: "Smussamento visivo (carico lento / scarico normale)",
colores_nivel: "Colori per livello (verde→rosso)",
enfoque_didactico: "Approccio didattico, facile da interpretare",
ndk_y_estado_ascenso: "NDL e stato della risalita",
indicadores_limites_descompresion: "Indicatori per comprendere i limiti senza decompressione e le abitudini di risalita.",
ndl_restante_2: "NDL rimanente",
recomendacion_parada_2: "Raccomandazione di sosta di sicurezza",
ceiling_si_aplica: "Ceiling (se applicabile)",
escala_tiempo_safety_stop: "Scala temporale (1×, 2×, 5×, 10×)",
acelerar_tiempo: "Puoi accelerare la simulazione per osservare più rapidamente come cambiano i valori. Questa funzione è utile per l’apprendimento: mostra l’andamento degli indicatori senza dover attendere lunghi periodi.",
safety_stop_title: "Safety Stop (sosta di sicurezza ricreativa)",
safety_stop_resumen: "Questo modulo simula la sosta di sicurezza a 5 metri nell’immersione ricreativa. La sua logica si basa sul controllo in tempo reale scalato, sulla tolleranza di profondità e sul rilevamento di interruzioni o ridiscese per validare o invalidare la sosta.",
deteccion_recomendacion: "Raccomandazione di sosta",
safety_recommendation_meta: "La sosta è raccomandata automaticamente in base al profilo di immersione.",
profundidad_maxima_safety_stop: "Si attiva se la profondità massima supera i 10 m",
exclusion_descompresion: "Si disattiva se è presente decompressione attiva o richiesta",
estado_recomendado: "Stato: recommended → attiva la sosta di sicurezza",
callback_recomendacion: "Callback opzionale di notifica all’utente",
logica_ejecucion: "Logica di esecuzione",
safety_execution_meta: "Il sistema controlla il tempo nella zona dei 5 metri con tolleranza e scalatura temporale.",
zona_parada: "Zona di sosta: 5 m ± 2 m",
zona_pausa: "Zona di pausa: 5 m - 3 m (nessun progresso)",
acumulacion_tiempo_safety_stop: "Accumulo del tempo in secondi simulati",
escala_tiempo: "Scalatura tramite velocità di simulazione (GET_TIME_SCALE)",
completado_3min: "Completato dopo 180 secondi effettivi",
pausa_reanuda: "Pausa automatica quando si esce dalla zona",
interrupciones_redescenso: "Interruzioni e ridiscesa",
safety_interrupt_meta: "Rileva se il subacqueo lascia la sosta o torna in profondità dopo averla completata.",
rompe_parada: "Uscire dalla zona invalida il progresso",
cancelacion: "Lo stato “cancelled” attiva il reset del monitoraggio",
interrupted_flag: "Segna un’interruzione se la logica viene interrotta",
redescenso_invalida: "Ridiscese > 6 m riattivano la raccomandazione",
ventana_tiempo: "Finestra di 30 s per invalidazione post-completamento",
safety_stop_tiempo: "Controllo del tempo in sosta",
safety_stop_explicacion: "Il tempo viene calcolato in tempo reale simulato, accumulandosi solo quando il subacqueo rimane nel range corretto. Se esce dalla zona, il contatore si mette in pausa. Se completa i 3 minuti effettivi, la sosta viene segnata come completata. Tuttavia, una successiva ridiscesa può invalidarla in determinate condizioni fisiologiche.",
nitrogen_load_title: "Barra di carico di azoto (UI educativa)",
nitrogen_load_resumen: "Questo modulo visualizza in tempo reale il carico di azoto nei tessuti rapidi del subacqueo. Il suo scopo è educativo: mostrare come evolve la saturazione relativa durante l’immersione tramite una barra di progresso smussata e codificata a colori.",
visualizacion_n2: "Visualizzazione del carico di N₂",
n2_visual_meta: "Rappresenta in modo semplificato il livello di saturazione di azoto nei tessuti rapidi.",

 ppo2_vizualiza:"PPO₂ e CNS",
    ppo2_visualiza_desc:"Visualizza la tossicità dell'ossigeno utilizzando PPO₂ e CNS accumulato. Lo stato è rappresentato tramite livelli di rischio fisiologico.",
    ppo2_visualiza_p1:"Colori illustrativi del livello di tossicità",
    ppo2_visualiza_p2:"CNS accumulato",

    profundimetro:"Profondità in tempo reale",
    profundimetro_educativa:"Monitoraggio continuo della profondità per comprendere meglio l'evoluzione del profilo d'immersione.",
    profundimetro_visualiza_p1:"Aggiornamento dinamico della profondità durante tutta l'immersione.",
    profundimetro_visualiza_p2:"Smussamento visivo che simula il comportamento degli strumenti reali.",




   tejidos_rapidos: "Basato sui tessuti rapidi del modello fisiologico",
valor_porcentual: "Valore espresso in percentuale (0–130%)",
suavizado_visual_2: "Smussamento visivo per evitare salti bruschi",
actualizacion_tiempo_real: "Aggiornamento in tempo reale",
codigo_colores_n2: "Codifica a colori",
n2_colors_meta: "La barra cambia colore in base al livello di carico per facilitare un’interpretazione rapida.",
verde_seguro: "Verde: carico basso e stabile (< 60%)",
amarillo_atencion: "Giallo: zona di attenzione (60%–85%)",
naranja_alto: "Arancione: carico elevato (85%–100%)",
rojo_riesgo: "Rosso: potenziale sovrasaturazione (> 100%)",
logica_suavizado: "Logica di smussamento e stabilità",
n2_smoothing_meta: "Il valore visivo non cambia istantaneamente, ma si avvicina progressivamente al valore reale.",
interpolacion_visual: "Interpolazione progressiva (ease-in / ease-out)",
respuesta_diferencial: "Risposta più lenta all’aumento rispetto alla diminuzione",
prevencion_flicker: "Prevenzione dello sfarfallio visivo",
clamp_visual: "Limitazione dei valori tra 0% e 130%",
n2_bar_texto_secundario: "Informazioni secondarie (GF / stato fisiologico)",
n2_bar_explicacion: "La barra può includere testo aggiuntivo (come Gradient Factor o stato del modello fisiologico). Ciò consente di correlare visivamente la saturazione di azoto con lo stato di decompressione, offrendo una rappresentazione più intuitiva del rischio accumulato.",
air_consumption_title: "Consumo d’aria (AL80 multi-bombola)",
air_consumption_resumen: "Questo modulo simula il consumo reale di gas in tempo dinamico utilizzando SAC (Surface Air Consumption), pressione ambientale e scala temporale. Supporta configurazioni con una o più bombole e calcola l’esaurimento progressivo dell’intero sistema.",
modelo_consumo: "Modello di consumo",
air_model_meta: "Il consumo si basa sul SAC del subacqueo adattato alla pressione ambientale e al tempo simulato.",
sac_rate: "SAC configurabile dall’utente",
presion_ambiente: "Pressione ambientale = 1 + profondità/10",
escala_tiempo_aire: "Scalato da GET_TIME_SCALE()",
consumo_proporcional: "Consumo proporzionale per bombola",
sistema_multitanque: "Sistema multi-bombola",
air_tanks_meta: "Il sistema distribuisce il consumo tra tutte le bombole attive dell’attrezzatura.",
al80_base: "Bombola base AL80 (2265 L)",
multi_tank_support: "Supporto per più bombole",
division_consumo: "Consumo diviso tra le bombole attive",
estado_out_of_air: "Stato globale OUT OF AIR",
visualizacion_hud_aire: "Visualizzazione HUD",
air_hud_meta: "Ogni bombola è rappresentata con una barra verticale di livello e lettura della pressione in bar e PSI.",
nivel_visual_barra: "Livello visivo per percentuale di volume",
bar_psi_conversion: "Conversione bar / PSI in tempo reale",
colores_reserva: "Colore in base alla riserva (verde → arancione → rosso)",
alerta_reserva_aire: "Allerta sotto i 35 bar",
air_system_tank_title: "Stato del sistema d’aria",
air_system_explainer: "Il sistema calcola il volume totale rimanente sommando tutte le bombole attive. Il consumo viene aggiornato a ogni frame simulato e consente di rilevare il punto di riserva o la condizione critica di “senza aria”. Il modello riflette sia il consumo individuale sia quello globale.",
oxygen_toxicity_title: "Tossicità dell’ossigeno (NOAA CNS)",
oxygen_toxicity_resumen: "Questo modulo valuta il rischio di tossicità dell’ossigeno utilizzando PPO₂ e CNS accumulato. Lo stato è rappresentato tramite livelli di rischio fisiologico simili a un computer subacqueo.",
ppo2_model: "Pressione parziale dell’ossigeno (PPO₂)",
ppo2_meta: "Determina il rischio immediato di tossicità acuta.",
formula_ppo2: "PPO₂ = FO₂ × pressione ambientale",
limite_ppo2: "Limite operativo: 1,4 bar",
limite_critico: "Critico: ≥ 1,6 bar",
cns_model: "CNS (Sistema nervoso centrale)",
cns_meta: "Accumulo progressivo dell’esposizione all’ossigeno secondo il modello NOAA.",
noaa_model: "Modello di esposizione NOAA",
acumulacion_cns: "Incremento progressivo nel tempo",
limite_cns: "100% = limite raccomandato",
estado_oxigeno: "Stato di tossicità dell’ossigeno",
oxy_state_meta: "Valutazione combinata di PPO₂ e CNS in tempo reale.",
stateOK: "OK",
stateWARN: "ATTENZIONE",
stateDANGER: "PERICOLO",
state_ok: "OK: esposizione entro limiti sicuri",
state_warning: "ATTENZIONE: zona di cautela",
state_danger: "PERICOLO: rischio di tossicità acuta",
oxygen_system_title: "Modello di rischio dell’ossigeno",
oxygen_system_explainer: "Il sistema combina la tossicità acuta (PPO₂) e quella cumulativa (CNS). Lo stato mostrato riflette il livello di rischio dominante in ogni momento dell’immersione, simile a un vero computer subacqueo tecnico.",
logica_deco_engine: "Logica del motore di decompressione (Bühlmann + GF)",
resumen_logica_deco: "Questo modulo calcola in tempo reale il piano di decompressione del subacqueo simulando la saturazione dei tessuti con azoto, generando soste obbligatorie e regolando il profilo di risalita in base allo stato fisiologico e al gradiente di sicurezza (GF). Mantiene inoltre uno storico persistente per non perdere i progressi tra le rigenerazioni del piano.",
generacion_plan: "Generazione del piano di decompressione",
plan_buhlmann: "Il sistema costruisce un profilo di soste basato sul modello Bühlmann con Gradient Factors.",
calculo_ceiling: "Calcolo del ceiling con linea GF (limite di risalita sicuro)",
redondeo_paradas: "Arrotondamento a step di sosta (STOP_STEP_M)",
simulacion_exposicion: "Simulazione del carico dei tessuti per sosta",
condicion_fin: "Termina quando il ceiling scende sotto i 3 m (STOP_REQUIRED_M)",
modo_preview: "Modalità anteprima senza influenzare lo storico reale",
historial_persistencia: "Storico e persistenza delle soste",
deco_history: "Il sistema salva i progressi di ogni sosta per evitare la perdita di stato durante le rigenerazioni.",
decohistory_array: "decoHistory memorizza i progressi per profondità",
hydrate_paradas: "Idratazione delle soste dallo storico",
preserva_progreso: "Preserva il tempo eseguito (timePerformedSec)",
evita_reset: "Evita il reset delle soste già iniziate",
merge_plan: "Fusione tra nuovo piano e stato precedente",
update_deco_logic: "Il motore ricalcola continuamente lo stato di decompressione in base a profondità, tempo simulato e tessuti.",
control_parada_actual: "Controllo della sosta attuale con tolleranza di profondità",
bloqueo_orden: "Blocco dell’ordine (impossibile saltare soste precedenti)",
regeneracion_dinamica: "Rigenerazione se il profilo peggiora o migliora",
acumulacion_tiempo: "Accumulo del tempo per dtSimSec",
auto_complete: "Completamento automatico al 95%",
tts_dinamico: "Calcolo dinamico del TTS (risalita + soste)",
tts_resumen: "Tempo totale alla superficie (TTS)",
tts_explicacion: "Il TTS viene calcolato combinando il tempo di risalita segmento per segmento (in base alla velocità di risalita) con il tempo restante nelle soste di decompressione attive. Il risultato si adatta continuamente in base allo stato reale dei tessuti e al piano corrente.",
uso_responsable: "Uso responsabile e avviso importante",
herramienta_educativa: "Questo progetto è uno strumento educativo e illustrativo. La subacquea reale richiede formazione, attrezzatura certificata e supervisione professionale.",
importante: "Importante",
que_hace_3_txt: "Questo simulatore <strong>non è</strong> un corso di subacquea, <strong>non sostituisce</strong> una formazione formale e <strong>non è</strong> un computer subacqueo né uno strumento operativo di pianificazione. <strong>Non deve</strong> essere utilizzato per pianificare immersioni reali né per prendere decisioni. Tutto ciò che viene mostrato è <strong>solo a scopo illustrativo</strong>, utilizzando concetti e algoritmi applicati esclusivamente per simulazione e visualizzazione. L’uso del simulatore è responsabilità dell’utente.",
ackCheck: "",
entiendo_educativo: "Comprendo che questo simulatore è solo a scopo educativo, non sostituisce una formazione certificata né un computer subacqueo e non deve essere utilizzato per pianificare o effettuare immersioni reali.",
enterBtn: "Entra nel simulatore",
learnMoreBtn: "Visualizza i dettagli del sistema",
faq_txt_2: "Domande frequenti",
que_es: "È un pianificatore di immersioni?",
es_aprendizaje_visual: "No. È uno strumento di apprendimento visivo. Non deve essere utilizzato per pianificare immersioni reali.",
que_gases_contempla: "Quali gas sono considerati?",
cuales_gases: "Sono considerati aria e Nitrox tramite la frazione di ossigeno (FO₂), influenzando NDL, azoto e PPO₂/CNS.",
mobil_funciona: "Funziona su mobile?",
si_funciona_mobil: "Sì. I controlli si adattano con joystick e gestione degli eventi di puntatore (pointer events).",
team_txt_2: "Team",

se_descarga: "È necessario scaricarla?",
no_se_descarga: "Utilizziamo la tecnologia <strong>3D WebGL</strong> per evitare qualsiasi download da uno store di applicazioni e offrirti un accesso libero e illimitato direttamente dal tuo browser.",


gonzalo_desc: "Istruttore subacqueo | Tecnico software",
title_footer: "Simulatore di immersione",
footer_experiencia: "Esperienza educativa e illustrativa",
consejo_ambiental: "Consiglio ambientale: mantenere una buona assetto e movimenti consapevoli protegge la barriera corallina e la vita marina.",
modalTitle: "Riepilogo del sistema",
closeModalBtn: "Chiudi",
actualiza_indicadores: "Il simulatore aggiorna gli indicatori di sicurezza e fisiologia durante l’immersione virtuale e genera un report finale per l’apprendimento.",
fisiologia: "Fisiologia (tessuti)",
compartimentos_2: "16 compartimenti simulati, carico di azoto e stima di ceiling/risalita.",
ndl_nitros: "NDL e Nitrox",
ndl_recreativo: "NDL ricreativo, supporto FO₂ con profondità equivalente (EAD) a fini educativi.",
consumo_aire_2: "Consumo d’aria",
consumo_basado_sac: "Consumo basato su SAC, pressione ambientale e tempo simulato; avvisi di riserva e mancanza d’aria.",
oxigeno_cns: "Ossigeno (PPO₂ / CNS)",
calculo_ppo2: "Calcola PPO₂ in base a profondità e FO₂; accumula esposizione CNS e mostra avvisi.",
fines_educativos: "Nota: tutti i valori e le visualizzazioni sono a fini educativi e di simulazione.",
closeSlideBtn: "❌",

safety_stop_menu: "Sosta di sicurezza",
nitrogen_bar_menu: "Barra N₂",
consumo_aire_menu: "Consumo di gas",
oxicidad_oxigeno_menu: "Tossicità O₂",
deco_menu: "DECO",
deco_y_paradas_deco: "DECO e le sue soste di decompressione",

registro_existoso: "Registrazione completata!",
instrucciones_email_registro: "Il tuo account è stato creato con successo. Verifica il tuo account nella tua email per accedere! Grazie",
cintinuar: "Continua",


},


payment_stripe:{

  title:"Pagamento sicuro con Stripe",
  ammount_txt:"Totale da pagare:<br>",
  currency:"Euro",
  pagar_ahora:"Paga ora",
  continuar:"Continua",
  cancelar:"Annulla",
  error: "Errore",
  completa_inputs:"Si prega di completare tutti i campi",
  close:"Chiudi",
  error_passwords:"Errore password",
  passwords_no_iguales:"Le password non corrispondono",
  error_email: "Errore email",
  ingresa_email_valido:"Inserisci un indirizzo email valido.",
  user_data:"Dati utente",
  create_account:"Crea un nuovo account",
  pago_exitoso:"Pagamento riuscito",
  pago_compeltado:"Il tuo pagamento è stato completato con successo",
  pago_proceso:"Pagamento in elaborazione",
  confirmaremos_pago:"Confermeremo il tuo pagamento a breve",
  pago_fallido:"Pagamento fallito",
  fallo_autenticacion_declinado:"Autenticazione fallita o pagamento rifiutato",
  status_pago:"Stato del pagamento",
  cuenta_existente:"Questo account esiste già",
  cuenta_existente_txt:"Questo indirizzo email è già stato registrato"

},




login:{

  iniciar_session: "Accedi",
  accede_a_cuenta:"Accedi al tuo account",
  email:"Email",
  password:"Password",
  iniciar_session_btn:"Accedi ora",
  verificando:"Verifica in corso.....",
  credenciales_incorrectas:"Credenziali non valide"

},


stripe_user_data:{
  user_data:"Dati utente",
  create_account:"Crea un nuovo account",
  username:"Nome utente",
  enter_username:"Inserisci il nome completo",
  email_user:"Email utente",
  enter_email:"Inserisci un'email",
  password:"Password",
  enter_password:"Inserisci una password",
  repeat_password:"Ripeti la password",
  enter_repeat_password:"Inserisci la stessa password",
  seleccion_suscripcion:"Seleziona il tipo di abbonamento",
  mensual:"Mensile",
  semestral:"Semestrale",
  anual:"Annuale"
},

cookies:{
  title:"Cookie Richiesti",
  message:"Questo sito richiede i cookie per funzionare correttamente. È necessario accettarne l’uso per continuare.",
  reject:"Rifiuta",
  accept:"Accetta",
  acceso_denegado:"Accesso negato",
  debes_aceptar:"È richiesta l’autorizzazione dei cookie per continuare"
},


condiciones:{

  full:  ` 


<div id="legal_conditions" class="legal_conditions">

<div class="legal_header">
<h1>Termini e Condizioni di Utilizzo</h1>
</div>


<div id="legal_scroll_container" class="legal_scroll_container">


<div class="section_legal">

<h2>1. IDENTIFICAZIONE DEL RESPONSABILE</h2>

<p>
In conformità con la Legge 34/2002 sui Servizi della Società dell’Informazione (LSSI-CE),
si informa che il presente sito web è di proprietà di:
</p>

<ul>
<li><strong>DIVANTIS</strong></li>
<li><strong>Email di contatto:</strong> admin@divantys.com</li>
<li><strong>Domicilio fiscale:</strong> Málaga, Spagna</li>
<li><strong>Attività:</strong> fornitura di servizi digitali remoti</li>
</ul>

</div>


<div class="section_legal">

<h2>2. OGGETTO E CONDIZIONI DI UTILIZZO</h2>

<p>
Questo sito web offre servizi digitali,
contenuti interattivi e strumenti online.
L’accesso al sito implica l’accettazione
delle presenti condizioni.
</p>

<p>L’utente si impegna a:</p>

<ul>
<li>Non svolgere attività illegali</li>
<li>Non introdurre codice dannoso</li>
<li>Non tentare di accedere a sistemi riservati</li>
<li>Non utilizzare il sito per scopi fraudolenti</li>
</ul>

</div>


<div class="section_legal">

<h2>3. PROPRIETÀ INTELLETTUALE</h2>

<p>
Tutti i contenuti del sito (testi, codice, design,
software e immagini) sono di proprietà del titolare
o utilizzati con licenza.
È vietata la riproduzione, distribuzione o modifica
senza autorizzazione espressa.
</p>

</div>


<div class="section_legal">

<h2>4. DISPONIBILITÀ DEL SERVIZIO</h2>

<p>
Il titolare può modificare, sospendere
o interrompere qualsiasi servizio o funzionalità
del sito in qualsiasi momento senza preavviso.
</p>

</div>


<div class="section_legal">

<h2>5. LIMITAZIONE DI RESPONSABILITÀ</h2>

<p>
Il sito è fornito “così com’è”.
Il titolare non garantisce la disponibilità continua
né l’assenza di errori tecnici.
</p>

<p>
Il titolare non sarà responsabile per eventuali danni
derivanti dall’uso o dall’impossibilità di utilizzare
i servizi offerti.
</p>

</div>


<div class="section_legal">

<h2>6. POLITICA SULLA PRIVACY (GDPR)</h2>

<h3>Dati raccolti</h3>

<ul>
<li>Nome</li>
<li>Indirizzo email</li>
<li>Dati inviati tramite moduli</li>
<li>Dati tecnici di navigazione</li>
</ul>

<h3>Finalità</h3>

<ul>
<li>Rispondere alle richieste</li>
<li>Inviare informazioni richieste</li>
<li>Migliorare il servizio</li>
<li>Comunicazioni commerciali (con consenso)</li>
</ul>

</div>


<div class="section_legal">

<h2>7. CONSERVAZIONE DEI DATI</h2>

<p>
I dati personali saranno conservati
solo per il tempo necessario a soddisfare
le finalità indicate in questa politica
o per adempiere agli obblighi di legge.
</p>

</div>


<div class="section_legal">

<h2>8. SERVIZI DI TERZE PARTI</h2>

<p>
Questo sito può utilizzare servizi di terze parti
come processori di pagamento, provider di hosting
o strumenti di analisi.
</p>

<p>
Tali fornitori possono trattare alcuni dati
tecnici o personali secondo le proprie
politiche sulla privacy.
</p>

</div>


<div class="section_legal">

<h2>9. TRASFERIMENTI INTERNAZIONALI DI DATI</h2>

<p>
Qualora vengano utilizzati fornitori tecnologici
situati al di fuori dello Spazio Economico Europeo,
verranno applicate le clausole contrattuali standard
approvate dalla Commissione Europea.
</p>

</div>


<div class="section_legal">

<h2>10. POLITICA DEI COOKIE</h2>

<p>
Il sito può utilizzare cookie tecnici e analitici
per migliorare l’esperienza dell’utente
e la funzionalità del sito.
</p>

</div>


<div class="section_legal">

<h2>11. MODIFICHE</h2>

<p>
Il titolare può modificare queste politiche
in qualsiasi momento.
Le modifiche entreranno in vigore
dal momento della pubblicazione sul sito.
</p>

</div>


<div class="section_legal">

<h2>12. LEGGE APPLICABILE E GIURISDIZIONE</h2>

<p>
Le presenti condizioni sono regolate
dalla legislazione spagnola.
Le parti si sottopongono ai tribunali
di Málaga, Spagna.
</p>

</div>


<div class="section_legal">

<h2>13. CONTATTO</h2>

<p>
Per qualsiasi richiesta relativa
a queste politiche:
</p>

<p>
📧 admin@divantys.com
</p>

</div>


</div>



<div class="legal_controls">

<button id="legal_continue_btn">
Accetta e continua
</button>

</div>

</div>

    ` 

},


// ===================================================
// GENERAL
// ===================================================
general: {
  ok: "OK",
  cancel: "Annulla",
  salir: "Esci",
  button_fisiologia: "Fisiologia dell'immersione",
  closeReset: "Chiudi e ripristina",
  startDive: "Inizia immersione",
  startNextDive: "Inizia immersione successiva",
  firstDive: "Prima immersione",
  repetitiveDive: "Immersione ripetitiva",
  Dive: "Immersione #",
  reduce_ascent_speed: "Ridurre la velocità di risalita diminuisce il sovraccarico di azoto.",
  controlled_ascent_text:
    "Ricorda che le risalite devono essere lente e controllate per evitare la saturazione dei tessuti. Usa il “Carico di Azoto” come riferimento."
},

// ===================================================
// ALERTS / MESSAGES
// ===================================================
alerts: {
  notice: "Avviso",
  invalidSurface: "Intervallo di superficie non valido",
  noRepetitive: "Le immersioni ripetitive non sono consentite dopo questa immersione",
  noTissueData: "Nessun dato sui tessuti disponibile",
  recalculating: "Ricalcolo dei compartimenti dei tessuti…",

  outOfAir: {
    title: "🚨 Senza aria",
    button: "Ho capito",
    html: `
      <strong>Situazione critica rilevata.</strong><br><br>

      • Riserva di gas esaurita<br>
      • Iniziare immediatamente una risalita controllata<br>
      • Espirazione continua (CESA)<br>
      • Mantenere una velocità di risalita sicura<br><br>

      <em>Questa immersione è stata terminata per motivi di sicurezza.</em>
    `
  },

  modExceeded: {
    icon: "🫁⚠️",
    color: "#c62828",
    title: "🚨 MOD superata per EAN{{ean}}",
    button: "Ho capito",
    html: `
      <strong>Ti trovi oltre la profondità operativa sicura per questo gas.</strong><br><br>

      <strong>Dettagli:</strong><br>
      • Profondità attuale: <strong>{{depth}} m</strong><br>
      • MOD (PPO₂ 1.4): <strong>{{mod}} m</strong><br>
      • Azione: <strong>risalire</strong> immediatamente a una profondità minore<br><br>

      <em>Questa immersione è stata terminata per motivi di sicurezza.</em>
    `
  },

  recreationalLimitExceeded: {
    icon: "🚫",
    color: "#c62828",
    title: "🚨 Limiti ricreativi superati",
    button: "Ho capito",
    html: `
      <strong>Hai superato i limiti standard dell'immersione ricreativa.</strong><br><br>

      <strong>Questo significa:</strong><br>
      • Il NDL ricreativo non è più valido<br>
      • Potrebbe essere richiesta decompressione<br>
      • È necessaria formazione tecnica<br>
      • Pianificazione del gas e soste di decompressione possono essere necessarie<br><br>

      <em>Questa immersione è stata terminata per motivi di sicurezza.</em>
    `
  },

  ndlExceeded: {
    icon: "⏱",
    color: "#c62828",
    title: "🚨 Limite senza decompressione superato",
    button: "Ho capito",
    html: `
      <strong>Hai superato il limite senza decompressione.</strong><br><br>

      <strong>Azione richiesta:</strong><br>
      • Risalire immediatamente, lentamente e in modo controllato<br>
      • Velocità massima di risalita: <strong>9–10 m/min</strong><br>
      • Effettuare una sosta di sicurezza a <strong>5 m per 3–5 minuti</strong><br><br>

      <em>Questa immersione è stata terminata per motivi di sicurezza.</em>
    `
  },

  safetyStopInterrupted: {
    title: "Sosta di sicurezza interrotta",
    text: "Scendi a 5 metri per riprendere la sosta di sicurezza.",
    color: "warning"
  },

  safetyStopCompleted: {
    title: "Sosta di sicurezza completata",
    text: "Puoi continuare la risalita in sicurezza.",
    color: "success"
  },

  low_air_reserve_reached: {
    title: "Aria bassa — Riserva raggiunta",
    text: `
La tua riserva d’aria è stata raggiunta (≈35 bar).

• Inizia una risalita lenta e controllata
• Non superare 9–10 m/min
• Preparati per la sosta di sicurezza a 5 m
• Mantieni la calma e respira lentamente`,
    color: "warning"
  }
},

// ===================================================
// LOGS / STATES
// ===================================================
logs: {
  decoRequired: "🚨 Decompressione richiesta (criterio ricreativo)",
  nearNDL: "⚠️ Vicino al limite senza decompressione",
  highTissue: "🟠 Alto carico dei tessuti (modello fisiologico)",
  withinLimits: "✅ Immersione entro i limiti ricreativi"
},

// ===================================================
// DIVE STATUS
// ===================================================
diveStatus: {
  completed: "✅ Immersione completata",
  failedDeco: "🚨 Immersione fallita — Decompressione richiesta",
  highTissue: "⚠️ Immersione completata — Alto carico dei tessuti",
  nearNDL: "⚠️ Immersione completata — Vicino al limite senza decompressione",
  dangerous_ascent: "🚨 A un certo punto hai avuto una risalita incontrollata. Fai attenzione",
fast_ascent: "⚠️ A un certo punto sei risalito più velocemente del limite massimo consentito (9 m/min). Controlla sempre la risalita e anticipa i cambi di profondità"
},

// ===================================================
// SAFETY STOP
// ===================================================
safetyStop: {
  title: "Sosta di sicurezza",
  completed: "✅ <strong>Sosta di sicurezza completata</strong>",
  notCompleted: "⚠️ <strong>Sosta di sicurezza non completata</strong>",
  timeAt5m: "Tempo a 5 m",
  completedAfterInterruptions: "Completata con interruzioni",
  back_5m: "⬆️ Torna a 5 m",
  hold_5m: "⏸ Mantieni a 5 m",
  target_depth: "Profondità target: 5 m"
},

nitrogen_bar: {
  title: "Carico N₂ (tessuti veloci)"
},

scale_time_home: {
  title: "Scala temporale della simulazione",
  text: `
    Questo simulatore può <strong>accelerare il tempo</strong> per aiutare a visualizzare
    i processi fisiologici (NDL, carico di azoto,
    comportamento in risalita) che nell'immersione reale richiedono molto più tempo.
    <br><br>
    Questo <strong>non</strong> rappresenta un'immersione in tempo reale ed è utilizzato
    <strong>esclusivamente per scopi educativi e visivi</strong>.
  `,
  real_time: "Tempo reale",
  choose: "Seleziona la velocità della simulazione:",
  start: "Inizia immersione"
},

// ===================================================
// REPORT / SUMMARY
// ===================================================
report: {
  diveNumber: "Immersione",
  time: "Tempo",
  maxDepth: "Profondità massima",
  gas: "Gas",
  tank: "Bombola",
  startPressure: "Pressione iniziale",
  endPressure: "Pressione finale",
  airUsed: "Aria utilizzata",
  sac: "SAC",
  reserveReached: "Riserva raggiunta",
  ceiling: "Ceiling",
  gf: "GF",
  tissueTitle: "Compartimenti dei tessuti",
  tissueNote:
    "I compartimenti rossi indicano tessuti limitanti — nessuna decompressione obbligatoria.",
  safetystop: "Sosta di sicurezza"
},

camera_hud: {
  t1: "Regola l’assetto neutro",
  level_ok: "✓ Neutro",
  level_hint: "Tocca ⦿ per assetto neutro"
},

// ===================================================
// PROFILE
// ===================================================
profile: {
  title: "Profilo di profondità"
},

// ===================================================
// TISSUES
// ===================================================
tissues: {
  title: "Compartimenti dei tessuti (N₂)",
  surfaceOffGassing: "Eliminazione gas in superficie",
  afterInterval: "Dopo",
  minutes: "min",
  offGas: "⬇ eliminazione gas",
  onGas: "⬆ assorbimento gas",
  tissues_data_invalidos: "Nessuna informazione sui tessuti disponibile"
},

// ===================================================
// SURFACE INTERVAL
// ===================================================
surface: {
  title: "Intervallo di superficie (min)",
  invalid_interval_surface: "Tempo di intervallo di superficie non valido",
  recalc: "Ricalcola tessuti",
  after: "Dopo",
  notAllowed: "Le immersioni ripetitive non sono consentite dopo questa immersione"
},

// ===================================================
// REPETITIVE DIVES
// ===================================================
repetitive: {
  tag: "Immersione ripetitiva",
  info:
    "Questa immersione inizia con azoto residuo da una precedente immersione. Si raccomanda una risalita conservativa e una sosta di sicurezza completa.",
  first_dive: "Prima immersione",
  repetitive_dive: "Immersione ripetitiva"
},

// ===================================================
// PRE-DIVE CHECK
// ===================================================
predive: {
  title: "Controllo di sicurezza pre-immersione",
  subtitle: "Controllo di sicurezza standard (BWRAF) e selezione del gas",
  selectGas: "Seleziona gas respiratorio",
  start: "Inizia immersione",
  cancel: "Annulla e ripristina",
  descargar: "Scaricare il rapporto",
  bwraf: {
    b: "GAV: gonfia / sgonfia, inflator funzionante",
    w: "Zavorra: quantità corretta, sgancio rapido libero",
    r: "Chiusure: cinghie, fibbie e bombola sicure",
    a: "Aria: valvola aperta, respira e controlla la pressione",
    f: "Finale: maschera, pinne, computer, compagno pronti"
  }
},



comparativa_tablas_tejidos_bhulmann: {
  text: `
    <div style="display:flex; flex-direction:column; gap:14px; line-height:1.65; color:#eaf4ff;">

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:18px; font-weight:700; margin-bottom:8px;">
          🧠📊 Tabelle vs Modello fisiologico
        </div>
        <div style="font-size:14px; opacity:.95;">
          Entrambi servono per stimare il limite di non decompressione (NDL), ma <strong>non funzionano allo stesso modo</strong>.
          Per questo motivo possono mostrare risultati diversi.
        </div>
      </div>

      <div style="display:grid; gap:12px;">
        
        <div style="background:rgba(0,153,255,.10); border:1px solid rgba(0,153,255,.25); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🔵 Tabelle ricreative (PADI / DSAT)
          </div>
          <div style="font-size:14px;">
            <div>⏱️ Forniscono un <strong>tempo fisso</strong> in base alla profondità.</div>
            <div>📚 Basate su studi e margini di sicurezza.</div>
            <div>🧮 <strong>Non calcolano</strong> il corpo in tempo reale.</div>
            <div>🟢 Semplici, veloci e facili da usare.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Esempio: a <strong>20 m</strong>, la tabella può indicare <strong>NDL ≈ 45 min</strong>.
          </div>
        </div>

        <div style="background:rgba(0,255,170,.08); border:1px solid rgba(0,255,170,.22); border-radius:16px; padding:16px;">
          <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
            🟢 Modello Bühlmann (questo simulatore)
          </div>
          <div style="font-size:14px;">
            <div>🧠 Simula <strong>16 tessuti virtuali</strong> del corpo.</div>
            <div>📈 Calcola in tempo reale l’assorbimento e il rilascio di azoto.</div>
            <div>⚙️ Si adatta al tuo profilo reale: <strong>profondità, tempo e gas</strong>.</div>
            <div>🎯 Più dinamico e realistico.</div>
          </div>

          <div style="margin-top:10px; font-size:14px; background:rgba(255,255,255,.05); border-radius:12px; padding:10px;">
            👉 Qui l’<strong>NDL non è fisso</strong>: corrisponde al momento in cui diventa necessaria una <strong>sosta di decompressione</strong>.
          </div>
        </div>

      </div>

      <div style="background:rgba(255,196,0,.10); border:1px solid rgba(255,196,0,.25); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          ⚠️ Perché non coincidono sempre?
        </div>
        <div style="font-size:14px;">
          <div>📚 Le tabelle ricreative sono più <strong>conservative</strong>.</div>
          <div>🧠 Il modello Bühlmann calcola continuamente ciò che accade realmente nel corpo.</div>
          <div>🔍 Per questo il simulatore può mostrare un NDL diverso rispetto alle tabelle classiche.</div>
        </div>
      </div>

      <div style="background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.08); border-radius:16px; padding:16px;">
        <div style="font-size:16px; font-weight:700; margin-bottom:8px;">
          💡 Riepilogo
        </div>
        <div style="font-size:14px;">
          <div>🔵 <strong>Tabelle</strong> = approssimazione semplice e conservativa</div>
          <div>🟢 <strong>Bühlmann</strong> = simulazione fisiologica più realistica</div>
        </div>

        <div style="margin-top:10px; font-size:14px; font-weight:600;">
          👉 Questo simulatore utilizza il modello Bühlmann per fornire una stima dell’NDL più dinamica.
        </div>
      </div>

    </div>
  `
},


block_student: {
    riesgo_accidente_disbarico: "Alto rischio di embolia gassosa",
    riesgo_microburbujas: "Rischio di microbolle",
    reducir_velocidad: "È necessario ridurre la velocità di risalita a 9m/min",
    ascenso_ideal: "Velocità di risalita ideale",
    ascenso_lento: "Risalita lenta. Corretto",
    ascent_rate: "Velocità di risalita"
},


dashboard:{
    profile_txt: "Il mio profilo",
    logout_txt:"Disconnettersi",
    welcome_label:"Benvenuto",
    payments_title:"Pannello pagamenti",
    startSimulatorBtn:"🎮 Avvia simulatore di immersione",
    view_payments:"Vedi pagamenti",
    view_simulator_logs:"Log del simulatore",
    paymentsEmpty:"Caricamento pagamenti...",
    response_title:"Pagamenti",
    activo_con_previa_cancelacion: "🎮 Accesso attivo (cancellazione programmata)",
    fecha_cancelacion_suscripcion: "⚠️ Il tuo abbonamento sarà cancellato il:",
    en_proceso_cancelacion: "🟠 Abbonamento in fase di cancellazione",
    acceso_hasta: "Accesso disponibile fino al:",
    despues_esta_fecha_no_acceso: "Dopo questa data l’accesso verrà rimosso automaticamente",
    suscripcion_finalizada: "💳 Abbonamento terminato",
    suscripcion_cancelada: "🔴 Abbonamento cancellato",
    acceso_habiliatdo: "🟢 Accesso abilitato:",
    upgrade_plan : "Modifica il mio piano",
    modificar_a :"Modifica a:",
    tienes_el_plan_maximo: "✨ Hai il piano massimo disponibile.",
    reactivar_suscripcion: "🔄 Riattiva abbonamento",
    cancelar_suscripcion: "❌ Cancella abbonamento",
    en_proceso: "⏳ Elaborazione...",
    cancelando: "⏳ Cancellazione...",
    cancelada: "✅ Cancellata",
    error: "❌ Errore",
    reactivando_suscripcion: "⏳ Riattivazione...",
    reactivada: "✅ Riattivata",
    no_pagos_aun: "Nessun pagamento registrato.",
    pagar: "💳 Pagare",
    pagado: "💳 Accreditato",
    activar_acceso_simulador: "💳 Attiva l'accesso al simulatore",
    sin_suscripcion_inactiva: "🔴 Nessun abbonamento attivo",
    membresia_title: "Abbonamento",
   credits_title: "Crediti",
   add_saldo: "Aggiungi crediti"
}



}
